import { useEffect, useState } from "react";
import { Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import styles from "./style.module.scss";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import AccountingPackageForm from "@components/forms/AccountingPackageForm";
import { AccountingPackageFormDataType } from "@/formTypes/AccountingPackageFormDataType";
import { AccountingPackageMode } from "@utils/accountingPackage/reports";
import { OpenAccountingPackagePubSub, OpenAccountingPackagePubSubPayload } from "@utils/pubsubs/PubSub";

/**
 * Un unico offcanvas para el paquete contable mensual y el anual: el `mode` que
 * llega por el PubSub decide el titulo y si el formulario pide el mes.
 */
const AccountingPackageOffCanvas = (props: DefaultOffCanvasProps) => {
    const { className } = props;
    const [defaultData, setDefaultData] = useState<AccountingPackageFormDataType>({} as AccountingPackageFormDataType);
    const [isOpen, setOpen] = useState(false);
    const [mode, setMode] = useState<AccountingPackageMode>("month");

    useEffect(() => {
        const unsubscribe = OpenAccountingPackagePubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenAccountingPackagePubSubPayload) => {
        setOpen(payload.openOffCanvas || false);
        if (payload.mode) {
            setMode(payload.mode);
        }
        setDefaultData(payload.toEmail ? { emails: payload.toEmail } : {});
    }

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const title = mode === "year" ? "Paquete Contable Anual" : "Paquete Contable Mensual";

    return (
        <DefaultOffCanvas
            className={className || styles.offCanvas}
            direction="end"
            isOpen={isOpen}
            onClosed={onCanvasClosed}
            toggle={() => toogleOffCanvas(!isOpen)}
        >
            <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                {title}
            </OffcanvasHeader>
            <OffcanvasBody>
                <Container>
                    <p>
                        Se generaran los reportes de ventas, compras y gastos del periodo en PDF y
                        Excel, y se enviaran comprimidos en un archivo ZIP a la direccion de correo
                        electronico indicada.
                    </p>
                    <AccountingPackageForm
                        mode={mode}
                        defaultData={defaultData}
                    />
                </Container>
            </OffcanvasBody>
        </DefaultOffCanvas>
    );
}

export default AccountingPackageOffCanvas;
